module.exports = __webpack_public_path__ + "img/73.c3f3ea10.jpg";